import { DPA } from '../../components/landing/DPA';

export function DPAPage() {
  return <DPA />;
}